import React, { useState, useEffect, useMemo } from 'react';
import { CMSDetails } from '../services/website.services';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link, useLocation, useParams } from "react-router-dom";
import { createMeta, setTitle } from '../../../utils/commonfunction';
import Page404 from './Page404';


const DynamicPages = () => {

    const params = useParams();
    const [loader, setLoader] = useState(true);
    const loc = useLocation();
    const [HTML, setHTML] = useState('');
    const [refreshOptions, setRefreshOptions] = useState(false);
    const [data,setData] = useState([]);


    useEffect(() => {
        CMSDetails(params?.slug).then((response) => {
            setTitle(response?.data?.title);
            createMeta(response?.data);
            setHTML(response?.data?.description);
            setData(response?.data?.title);
            setLoader(false);
        }).catch((error) => {
            setLoader(false);
            console.log("error of terms&conditions", error);
        })
    }, [loc, params?.slug, refreshOptions]);
    useMemo(() => {
        document.addEventListener('language_change', function () {
            setRefreshOptions(!refreshOptions);
        })
    });

    return (
        <>
            <div className='faq-pages'>
                {/* <div className="heading-banner-page">
                    <div className="container">
                        <h1>{data}</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb justify-content-center">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{data}</li>
                            </ol>
                        </nav>
                    </div>
                </div> */}
                <div className="wraper-inner cpt">
                    {loader ?
                        <div className="container py-4">
                            <Skeleton height={150} />
                            <Skeleton height={30} count={10} />
                        </div>
                        :
                        HTML ?
                            <div className='container py-4' style={{ minHeight: '70vh' }} dangerouslySetInnerHTML={{ __html: `${HTML || "N/A"}` }}></div>
                            : <Page404 homePath='/'></Page404>
                    }
                </div>
            </div>
        </>
    )
}

export default DynamicPages;